/**
 * Strip animated translucent panel fill on Android main-screen auth docks.
 * Solid color is applied on the form shell instead (see `mainScreenAndroidFormSurface.ts`).
 *
 * Call only from Android-gated paths inside `useAnimatedStyle` worklets.
 */
export type OverlayPanelAnimatedStyle = {
  opacity: number;
  transform?: unknown;
  backgroundColor?: string;
};

export function stripAndroidMainScreenOverlayPanelFill<T extends OverlayPanelAnimatedStyle>(panel: T): T {
  'worklet';
  return {
    ...panel,
    backgroundColor: 'transparent',
  };
}
